import { BaseSensorWebController } from '../../base/controller/BaseSensorWebController';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { AwsSensorComponent } from '../component/AwsSensorComponent';
import { AwsSensorView } from '../view/AwsSensorView';
import { templateAwsSensor } from '../view/template';
import { IListenerConfig, WebComponentEvent } from '../../../../framework/BaseWebComponentController';
import { SensorEvent } from '../../types/sensor-type';

export class AwsSensorController extends BaseSensorWebController {
  public component: BaseSensorWebComponent;
  public view: AwsSensorView;
  public viewConstructor: typeof AwsSensorView;

  constructor(component: AwsSensorComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AwsSensorView,
      viewTemplate: templateAwsSensor,
    });
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$accessKeyId,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$secretAccessKey,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$queueUrl,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$accessKeyId,
        event: SensorEvent.change,
        callback: this.trimField,
      },
      {
        element: this.view.dom.$secretAccessKey,
        event: SensorEvent.change,
        callback: this.trimField,
      },
    ]);
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$accessKeyId.resetField();
    this.view.dom.$secretAccessKey.resetField();
    this.view.dom.$queueUrl.resetField();
  }

  private trimField(ev: WebComponentEvent): void {
    if (/^(\s.*|.*\s)$/.test(ev.target.getAttribute('value') as string)) {
      ev.target.setAttribute('value', ev.detail.sourceEvent.trim());
    }
  }
}
